/**
 * LocationInfoService
 * Service for LocationInfo entity operations
 * Route: api/location-info
 * Controller: LocationInfoController.cs
 */
import { CrudService } from '../base/CrudService';
/**
 * LocationInfoService
 * Handles location info CRUD operations and custom endpoints
 * Maps to /api/location-info endpoint
 */
export class LocationInfoService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? LocationInfoService.DEFAULT_SERVICE_PATH,
            basePath: LocationInfoService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    // ==================== CUSTOM METHODS ====================
    /**
     * Get all info records for a specific location
     * GET /api/location-info/location/{locationId}
     * @param locationId - Location ID
     * @returns Array of location info records
     */
    async getByLocationId(locationId) {
        const response = await this.getByLocationIdRaw(locationId);
        return response.data ?? [];
    }
    /**
     * Get all info records for a specific location (raw)
     * @param locationId - Location ID
     * @returns ResponseData with array of location info records
     */
    getByLocationIdRaw(locationId) {
        const endpoint = this.getEndpoint('byLocationId', `location/${locationId}`);
        const url = this.buildUrl(endpoint);
        return this.http.get(url);
    }
}
LocationInfoService.DEFAULT_SERVICE_PATH = 'locations';
LocationInfoService.BASE_PATH = 'api/location-info';
//# sourceMappingURL=LocationInfoService.js.map